import Store_Storage from "./store-storage";

const STORAGE_KEY = "bd-game-session";
const TTL_MS = 24 * 60 * 60 * 1000;

const storageHelper = new Store_Storage("game-session");

export default class Store_GameSession {
  static save(gpId, teamCode) {
    const data = {
      gpId,
      teamCode,
      expiresAt: Date.now() + TTL_MS,
    };
    storageHelper
      .getSessionStorage()
      .setItem(STORAGE_KEY, JSON.stringify(data));
  }

  static load() {
    const raw = storageHelper.getSessionStorage().getItem(STORAGE_KEY);
    if (!raw) return null;

    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  static isValid() {
    const session = Store_GameSession.load();
    if (!session) return false;
    return session.expiresAt > Date.now();
  }

  static clear() {
    storageHelper.getSessionStorage().removeItem(STORAGE_KEY);
    storageHelper.getLocalStorage().removeItem(STORAGE_KEY);
  }
}
